var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"layout-container"}},[_c('Row',[_c('Col',[_c('Card',{attrs:{"bordered":false,"dis-hover":true}},[_c('div',{attrs:{"slot":"title"},slot:"title"},[_c('span',[_vm._v("用户手册")])]),_c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.con.content)}})])])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }